import React, { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';

export interface BreadcrumbItem {
  label: string;
  href?: string;
  onClick?: () => void;
}

export interface BreadcrumbsProps {
  items: BreadcrumbItem[];
  separator?: ReactNode;
  className?: string;
}

export const Breadcrumbs: React.FC<BreadcrumbsProps> = ({
  items,
  separator = (
    <ChevronRight className="w-4 h-4 text-muted-foreground" />
  ),
  className = '',
}) => {
  if (items.length === 0) return null;

  return (
    <nav
      aria-label="Breadcrumb"
      className={`flex items-center gap-2 ${className}`}
      data-id="breadcrumbs"
    >
      {items.map((item, index) => {
        const isLast = index === items.length - 1;

        return (
          <React.Fragment key={index}>
            {index > 0 && (
              <span className="flex items-center">{separator}</span>
            )}

            {item.href ? (
              <Link
                to={item.href}
                onClick={item.onClick}
                className={`text-sm font-medium transition-colors ${
                  isLast
                    ? 'text-foreground'
                    : 'text-foreground-secondary hover:text-primary-600 dark:hover:text-primary-400'
                }`}
              >
                {item.label}
              </Link>
            ) : item.onClick ? (
              <button
                onClick={item.onClick}
                className={`text-sm font-medium transition-colors ${
                  isLast
                    ? 'text-foreground'
                    : 'text-foreground-secondary hover:text-primary-600 dark:hover:text-primary-400'
                }`}
              >
                {item.label}
              </button>
            ) : (
              <span
                className={`text-sm font-medium ${
                  isLast
                    ? 'text-foreground'
                    : 'text-foreground-secondary'
                }`}
              >
                {item.label}
              </span>
            )}
          </React.Fragment>
        );
      })}
    </nav>
  );
};
